import { useCallback as S } from "react";
import { validateType as V, validateMaxSize as h, validateMinSize as k, validateCustom as F, validateMaxFilesCount as M } from "./validation.mjs";
const D = ({
  fileList: o = [],
  validation: a
}) => {
  const t = o.length;
  return S(
    (e, s) => {
      if (!a)
        return [];
      const { maxSize: l, minSize: u, types: c, customValidation: r, maxFilesCount: d } = a, m = V(e, c), v = h(e, l), y = k(e, u), z = F(e, r), p = M(
        s?.length || 0,
        t,
        d
      ), i = [
        { key: "maxSize", value: v },
        { key: "minSize", value: y },
        { key: "types", value: m },
        { key: "customValidation", value: z },
        { key: "maxFilesCount", value: p }
      ];
      return i.reduce(
        (n, x, C) => x.value ? n : n.concat(i[C].key),
        []
      );
    },
    [a, t]
  );
};
export {
  D as useDropzoneValidation
};
//# sourceMappingURL=useDropzoneValidation.mjs.map
